/**
* Tabbed Content With Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Content With Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-content-with-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.tabbed-content-with-slider' ).each( function( key, component ) {
        $( component ).find( '.main-slider' ).slick( {
          dots: false,
          arrows: false,
          slidesToShow: 1,
          asNavFor: $( component ).find( '.slider-navigation' )[0],
        } );

        $( component ).find( '.slider-navigation' ).slick( {
          dots: false,
          arrows: true,
          prevArrow: $( component ).find( '.prev-slide' )[0],
          nextArrow: $( component ).find( '.next-slide' )[0],
          slidesToShow: 5,
          asNavFor: $( component ).find( '.main-slider' )[0],
        } );

        $( component ).find( '.slider-navigation .slide button' ).on( 'click', function() {
          $( component ).find( '.main-slider' ).slick( 'slickGoTo', parseInt( $( this ).attr( 'data-slide' ) ) );
        } );

        const initialTab = $( component ).find( '.tabs-list li:first-child .tab' )[0];
        const initialPanel = $( component ).find( '.tab-panels .tab-panel:first-child' )[0];
        $( initialTab ).attr( 'tabindex', '0' ).attr( 'aria-selected', 'true' );
        $( initialPanel ).removeAttr( 'hidden' );
      } );

      const tablist = document.querySelectorAll( '[role="tablist"]' )[0];
      let tabs;
      let panels;

      generateArrays();

      function generateArrays() {
        tabs = document.querySelectorAll( '[role="tab"]' );
        panels = document.querySelectorAll( '[role="tabpanel"]' );
      }

      // For easy reference
      const keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        delete: 46,
        enter: 13,
        space: 32,
      };

      // Add or subtract depending on key pressed
      const direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1,
      };

      // Bind listeners
      for ( i = 0; i < tabs.length; ++i ) {
        addListeners( i );
      }

      function addListeners( index ) {
        tabs[index].addEventListener( 'click', clickEventListener );
        tabs[index].addEventListener( 'keydown', keydownEventListener );
        tabs[index].addEventListener( 'keyup', keyupEventListener );

        // Build an array with all tabs (<button>s) in it
        tabs[index].index = index;
      }

      // When a tab is clicked, activateTab is fired to activate it
      function clickEventListener( event ) {
        const tab = event.target;
        activateTab( tab, false );
      }

      // Handle keydown on tabs
      function keydownEventListener( event ) {
        const key = event.keyCode;

        switch ( key ) {
          case keys.end:
            event.preventDefault();
            // Activate last tab
            focusLastTab();
            break;
          case keys.home:
            event.preventDefault();
            // Activate first tab
            focusFirstTab();
            break;

          // Up and down are in keydown
          // because we need to prevent page scroll >:)
          case keys.up:
          case keys.down:
            determineOrientation( event );
            break;
        }
      }

      // Handle keyup on tabs
      function keyupEventListener( event ) {
        const key = event.keyCode;

        switch ( key ) {
          case keys.left:
          case keys.right:
            determineOrientation( event );
            break;
          case keys.delete:
            determineDeletable( event );
            break;
          case keys.enter:
          case keys.space:
            activateTab( event.target );
            break;
        }
      }

      // When a tablistâ€™s aria-orientation is set to vertical,
      // only up and down arrow should function.
      // In all other cases only left and right arrow function.
      function determineOrientation( event ) {
        const key = event.keyCode;
        const vertical = tablist.getAttribute( 'aria-orientation' ) == 'vertical';
        let proceed = false;

        if ( vertical ) {
          if ( key === keys.up || key === keys.down ) {
            event.preventDefault();
            proceed = true;
          }
        } else {
          if ( key === keys.left || key === keys.right ) {
            proceed = true;
          }
        }

        if ( proceed ) {
          switchTabOnArrowPress( event );
        }
      }

      // Either focus the next, previous, first, or last tab
      // depending on key pressed
      function switchTabOnArrowPress( event ) {
        const pressed = event.keyCode;

        if ( direction[pressed] ) {
          const target = event.target;
          if ( target.index !== undefined ) {
            if ( tabs[target.index + direction[pressed]] ) {
              tabs[target.index + direction[pressed]].focus();
            } else if ( pressed === keys.left || pressed === keys.up ) {
              focusLastTab();
            } else if ( pressed === keys.right || pressed == keys.down ) {
              focusFirstTab();
            }
          }
        }
      }

      // Activates any given tab panel
      function activateTab( tab, setFocus ) {
        setFocus = setFocus || true;
        // Deactivate all other tabs
        deactivateTabs();

        // Remove tabindex attribute
        tab.removeAttribute( 'tabindex' );

        // Set the tab as selected
        tab.setAttribute( 'aria-selected', 'true' );

        // Get the value of aria-controls (which is an ID)
        const controls = tab.getAttribute( 'aria-controls' );

        // Remove hidden attribute from tab panel to make it visible
        document.getElementById( controls ).removeAttribute( 'hidden' );

        $( tab ).closest( '.tabbed-content' ).find( '.tab-selector span' ).text( $( tab ).text() );

        // Set focus when required
        if ( setFocus ) {
          tab.focus();
        }
      }

      // Deactivate all tabs and tab panels
      function deactivateTabs() {
        for ( t = 0; t < tabs.length; t++ ) {
          tabs[t].setAttribute( 'tabindex', '-1' );
          tabs[t].setAttribute( 'aria-selected', 'false' );
        }

        for ( p = 0; p < panels.length; p++ ) {
          panels[p].setAttribute( 'hidden', 'hidden' );
        }
      }

      // Make a guess
      function focusFirstTab() {
        tabs[0].focus();
      }

      // Make a guess
      function focusLastTab() {
        tabs[tabs.length - 1].focus();
      }

      // Detect if a tab is deletable
      function determineDeletable( event ) {
        target = event.target;

        if ( target.getAttribute( 'data-deletable' ) !== null ) {
          // Delete target tab
          deleteTab( event, target );

          // Update arrays related to tabs widget
          generateArrays();

          // Activate the closest tab to the one that was just deleted
          if ( target.index - 1 < 0 ) {
            activateTab( tabs[0] );
          } else {
            activateTab( tabs[target.index - 1] );
          }
        }
      }

      // Deletes a tab and its panel
      function deleteTab( event ) {
        const target = event.target;
        const panel = document.getElementById( target.getAttribute( 'aria-controls' ) );

        target.parentElement.removeChild( target );
        panel.parentElement.removeChild( panel );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-content-with-slider', COMPONENT );
} )( app );
